import React from 'react'
import Icon from '../Icons/Icon'
import Loading from '../Loading'
import { classNames } from '../../Services/helpers'
import ButtonRow from '../Button/ButtonRow'

export default ({theme, loading, title, message, icon, className, onClick, buttons, onDismiss, hide}) => {
    const classes = {
        secondary: 'bg-gray-100 text-gray-900 fill-gray-900',
        error: 'bg-red-100 text-red-900 fill-red-900',
        danger: 'bg-red-100 text-red-900 fill-red-900',
        warning: 'bg-orange-100 text-orange-900 fill-orange-900',
        success: 'bg-green-100 text-green-900 fill-green-900',
        info: 'bg-blue-100 dark:bg-blue-900 text-blue-900 dark:text-blue-100 fill-blue-900 dark:fill-blue-100',
    }

    const icons = {
        secondary: 'CircleQuestion',
        error: 'CircleX',
        danger: 'CircleX',
        warning: 'Exclamation',
        success: 'Check',
        info: 'Info',
    }

    const both = title && message;

    if (hide) {
        return null;
    }

    return <div className={classNames(
            'relative flex row rounded-xl my-3 p-3',
            classes[theme] ?? classes.info,
            onClick && 'cursor-pointer',
            className,
        )}
        onClick={() => onClick && onClick()}
    >
        {onDismiss && <div className="absolute top-1 right-1 p-2">
            <Icon icon="XMark" size="1.5x" onClick={onDismiss} />
        </div>}
        {icon !== false && <div className={classNames('mr-3', both ? 'mt-2' : 'mt-2')}>
            {loading ? <Loading /> : <Icon icon={icon ? icon : icons[theme]} size={both ? '2x' : '1x'} />}
        </div>}
        <div className={classNames('grow text-sm', onDismiss && 'mr-4')}>
            {title && <p className="font-bold">
                {title}
            </p>}
            {message && <p className={classNames('text-pretty', title && 'my-2')}>{message}</p>}
            {buttons && <ButtonRow>
                {buttons}
            </ButtonRow>}
        </div>
    </div>
}
